module.exports = "/images/img_01.png?84ade91e024aa9a6355fa94fe4c2bf92";